import React, { useEffect, useState } from 'react';
import './news.scss';
import 'aos/dist/aos.css';
import { Pagination, AutoComplete, Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import FooterId from '../footer/FooterId';
import FooterEn from '../footer/FooterEn';
import { ArrowRightOutlined, ArrowDownOutlined } from '@ant-design/icons';
import metaThumbnail from '../data/images/meta/homeimage.png';
import MetaDecorator from '../Util/MetaDecorator';
import axios from 'axios';
import { PuffLoader } from 'react-spinners';
import { format } from 'date-fns';
import id from 'date-fns/locale/id';
import BASE_URL from '../Util/config';

const news = require('../data/json/news.json');

const News = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const newsPerPage = 5;
  const [filterType, setFilterType] = useState('newer');
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const isIdPath = window.location.pathname.startsWith('/en');
  const [loading, setLoading] = useState(false);
  const [filteredNews, setFilteredNews] = useState([]);

  const indexOfLastNews = currentPage * newsPerPage;
  const indexOfFirstNews = indexOfLastNews - newsPerPage;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const response = await axios.get(`${BASE_URL}/api/blog-news/public?type=news&status=published&company=1`);

        if (response.status === 200 && response.data.success) {
          const items = response.data.data;

          const newData = items
            .map((item) => {
              // Pastikan featured_image selalu lengkap URL-nya
              const thumbnailPath = item.featured_image || '';
              const fullThumbnail = thumbnailPath.startsWith('/uploads') ? `${BASE_URL}${thumbnailPath}` : thumbnailPath; // kalau sudah lengkap, tidak diubah

              return {
                id: item.id,
                short_title: item.title_id,
                tanggal: item.article_date,
                tanggalnew: item.article_date ? format(new Date(item.article_date), 'EEEE, d MMMM yyyy', { locale: id }) : '',
                thumbnail: fullThumbnail,
                gagasan_utama: item.excerpt_id,
                status_posting: true,
                endpoint: item.slug,
              };
            })
            .sort((a, b) => {
              const da = a.tanggal ? new Date(a.tanggal) : 0;
              const db = b.tanggal ? new Date(b.tanggal) : 0;
              return db - da;
            });

          setFilteredNews(newData);
        }
      } catch (error) {
        console.error('Terjadi kesalahan:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleFilter = () => {
    const newFilterType = filterType === 'newer' ? 'older' : 'newer';
    setFilterType(newFilterType);

    const sortedNews = [...filteredNews].sort((a, b) => {
      const dateA = new Date(a.tanggal);
      const dateB = new Date(b.tanggal);

      // older = ascending (lama ke baru), newer = descending (baru ke lama)
      return newFilterType === 'older' ? dateA - dateB : dateB - dateA;
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });
    setFilteredNews(sortedNews);
    setCurrentPage(1);
  };

  const handleReadMore = (id, endpoint) => {
    const encodedurl = encodeURIComponent(endpoint);
    navigate(`/news/${id}/${encodedurl}`);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
  };

  const filterNews = (newsItem) => {
    const { short_title } = newsItem;
    const searchLowerCase = searchTerm.toLowerCase();
    return short_title.toLowerCase().includes(searchLowerCase);
  };

  return (
    <div>
      <MetaDecorator description={news.pageDescriptionId} title={news.pageTitleId} imageUrl={metaThumbnail} imageAlt={news.metaImageAltId} />
      <div className="contentNews" data-aos="fade-down">
        <div className="news-content d-flex align-items-center justify-content-center">
          <div className="content-text">
            <h2 className="textHero" data-aos="fade-up">
              BERITA
            </h2>
          </div>
        </div>

        {loading ? (
          <div className="loading-spinner-news">
            <PuffLoader color="#007bff" size={100} margin={2} />
          </div>
        ) : (
          <div className="bottomNews">
            <div className="filter-search">
              <div className="filterTop">
                <div>
                  <Button type="default" icon={<ArrowDownOutlined rotate={filterType === 'newer' ? 180 : 0} />} onClick={handleFilter} />
                </div>
                <AutoComplete className="autoComplete" placeholder="Cari Berita..." onChange={handleSearch} />
              </div>
              <div className="page"> Halaman {currentPage}</div>
            </div>
            <div className="middle">
              {filteredNews
                .filter(filterNews)
                .slice(indexOfFirstNews, indexOfLastNews)
                .map((news) => (
                  <div key={news.id} className="bodyNews">
                    <div className="newsImage">
                      <img src={news.thumbnail} alt={news.short_title} />
                    </div>

                    <div className="desc">
                      <h2>{news.short_title}</h2>
                      <h5>{news.tanggalnew}</h5>
                      <p>{news.gagasan_utama}</p>

                      <div className="footer">
                        <hr />
                        <Link to={`/news/${news.id}/${news.short_title.replace(/ /g, '-')}`} onClick={() => handleReadMore(news.id, news.endpoint)}>
                          LIHAT SELENGKAPNYA <ArrowRightOutlined />
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="pagination">
              <Pagination current={currentPage} pageSize={newsPerPage} total={filteredNews.length} onChange={handlePageChange} />
            </div>
          </div>
        )}

        <div className="footer">{isIdPath ? <FooterEn /> : <FooterId />}</div>
      </div>
    </div>
  );
};

export default News;
